module.exports = __webpack_public_path__ + "img/multiselect-arrow.1e4ae320.svg";